'use strict';

import * as types from '../../types';
import actions from './actions';
import ua from '../../../libs/user-agenet';

// States
let state = {
  credentials:        {
    accessKeyId:     null,
    secretAccessKey: null,
    sessionToken:    null
  },
  tokenExpireTime:    null,
  tokenRemainTimeMs:  null,
  cognitoIdentityId:  null,
  registration:       {
    linePin: null,
    msgPin:  null
  },
  userToken:          null,
  userTokenExpiredAt: null
};

/**
 * 認証情報を格納する
 * @param state
 * @param credentials
 */
function storeCredentials(state, credentials){
  state.cognitoIdentityId = credentials.identityId;
  state.credentials       = {
    accessKeyId:     credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken:    credentials.sessionToken
  };
  
  state.tokenExpireTime = credentials.expireTime;
  let remain            = state.tokenExpireTime - (new Date()) + 1;
  if(remain < -1){
    state.tokenRemainTimeMs = 0;
  }
  else{
    state.tokenRemainTimeMs = remain;
  }
  
  // mixpanelでユーザのplatform情報を入れる
  mixpanel.identify(state.cognitoIdentityId);
  mixpanel.people.set({
    platform:                    window.navigator.platform,
    isSmartphoneByPlatform:      ua.isSmartPhoneByPlatform(),
    maxTouchPoints:              window.navigator.maxTouchPoints,
    cognitoIdentityId:           state.cognitoIdentityId,
    isObjectOnOrientationChange: typeof window.onorientationchange === 'object'
  });
}

// Mutations
let mutations = {
  [types.INITIALIZE_COGNITO](state, {credentials}){
    storeCredentials(state, credentials);
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/store.js